// extracted by mini-css-extract-plugin
module.exports = {"AboutUs":"_2Z4IQBtAa5BXFsPC-MTLTn","header":"_3sjdvv0-3WAg6tAB6OaGQA","Image":"_8c7r4AJQzEXCNpAxO4Uqc","Content":"_3sd_miAE4eujR7M9YpVYY1","Mission":"_3nIRHcDMFJbY3rvcHWksKn"};